import { Components, menuItemClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * MuiMultiSectionDigitalClockSection to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/multi-section-digital-clock/#css
 */

export const MuiMultiSectionDigitalClockSection: Components<Theme>['MuiMultiSectionDigitalClockSection'] = {
  styleOverrides: {
    item: ({ theme }) => {
      const rebrand = theme.featureFlags.panwRebrandStubYear;
      return {
        ...(rebrand
          ? {
              '&:hover': {
                backgroundColor: theme.palette.table.rowHoverBackground,
              },
            }
          : {}),
        [`&.${menuItemClasses.selected}`]: {
          backgroundColor: rebrand ? theme.palette.table.rowSelectedBackground : theme.palette.primary.main,
          color: rebrand ? theme.palette.text.default : theme.palette.text.inversePrimary,
          '&:focus-visible, &:hover': {
            backgroundColor: rebrand
              ? // sc-164282
                // in legacy world this works without the !important, but it wasn't in the new world for some reason
                `${theme.palette.table.rowHoverBackground} !important`
              : theme.palette.primary.dark,
          },
        },
      };
    },
  },
};
